import { images } from './images';
import type { Audience, Benefit, Step } from '../types/content';

export const communityLinks: { to: string; title: string; text: string; image: string; alt: string }[] = [
  { to: '/destinations#seasonal', title: 'Summer and winter programmes', text: 'Camps, mini-stays and short courses with trips and activities.', image: images.social, alt: 'Students on a city walking tour' },
  { to: '/about/media', title: 'Student life in pictures', text: 'See our classrooms, student homes and weekend trips.', image: images.campusLife, alt: 'A group of students walking outside a school building' },
];

export const audiences: Audience[] = [
  {
    id: 'adults',
    label: 'Adults',
    text: 'Improve your everyday English and speak with more confidence at work, on trips and with new friends.',
    image: images.speaking,
    courses: ['general-english-30-plus', 'speaking-class', 'english-private-lessons'],
  },
  {
    id: 'professionals',
    label: 'Professionals',
    text: 'Use English in meetings, emails and presentations, or gain a business qualification taught in English.',
    image: images.teacher,
    courses: ['business-english', 'digital-marketing', 'athe-diplomas'],
  },
  {
    id: 'students',
    label: 'University students',
    text: 'Prepare for IELTS or for study at an English-speaking university with exam and academic skills.',
    image: images.classroom,
    courses: ['ielts-preparation', 'academic-english', 'general-english'],
  },
  {
    id: 'young',
    label: 'Teens and children',
    text: 'For parents: safe, planned courses where your child learns English, makes friends and has fun.',
    image: images.young,
    courses: ['language-camps', 'academic-camps', 'mini-stays'],
  },
  {
    id: 'teachers',
    label: 'Teachers',
    text: 'Start a teaching career with CELTA, or bring new methods to your class with our teacher training.',
    image: images.hero,
    courses: ['celta-certification', 'teacher-training-course', 'general-english'],
  },
];

export const homeBenefits: Benefit[] = [
  {
    title: 'Highly qualified native teachers',
    text: 'All our teachers are certified native English speakers with years of experience teaching English as a second language.',
  },
  {
    title: 'Support in 20+ languages',
    text: 'Our support team speaks more than 20 languages, so you get help with your goals and next steps in your own language.',
  },
  {
    title: 'A stunning modern campus',
    text: 'Our 2,783 sqm Dubai campus has smart classrooms, cafés, a library and leisure areas.',
  },
  {
    title: 'Students from around the world',
    text: 'Make friends from over 100 nationalities in a truly international student community.',
  },
  {
    title: 'A dedicated careers office',
    text: 'Get career advice, use our active job board and join regular workshops on CVs, networking and interviews.',
  },
  {
    title: 'Social activities programme',
    text: 'Join 20+ free and affordable activities every month and practise your English outside class.',
  },
];

export const enrolmentSteps: Step[] = [
  { title: 'Choose your course', text: 'Pick a course and a location. Our team can help you compare options.' },
  { title: 'Take the free level test', text: 'Complete a short online test, so we place you in the right class.' },
  { title: 'Receive your offer letter', text: 'We confirm your place and help you with your visa documents.' },
  { title: 'Start on a Monday', text: 'Meet your teacher and classmates on your first day at the campus.' },
];
